import { deleteRequest, getRequest, postRequest, putRequest } from 'config/Axios/baseConfig';
import {
  DefaultBpmByPillCountPayload,
  DefaultBpmByPillCountResponse,
  DefaultBpmByPillCountSingleResponse
} from 'Interfaces/ReferenceInterfaces/DefaultBpmByPillCountInterface';

export const defaultBpmByPillCountServices = {
  getAllDefaultBpmByPillCounts: (
    page = 1,
    pageSize = 10000
  ): Promise<DefaultBpmByPillCountResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<DefaultBpmByPillCountResponse>(
          `pps/default-bpm-by-pill-counts?page=${page}&page_size=${pageSize}`
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getDefaultBpmByPillCountById: (id: number): Promise<DefaultBpmByPillCountSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<DefaultBpmByPillCountSingleResponse>(
          `pps/default-bpm-by-pill-counts/${id}/`
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  createDefaultBpmByPillCount: (
    defaultBpmByPillCountData: DefaultBpmByPillCountPayload
  ): Promise<DefaultBpmByPillCountSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<DefaultBpmByPillCountSingleResponse>(
          'pps/default-bpm-by-pill-counts/',
          defaultBpmByPillCountData
        );
        resolve(data);
      } catch (error: any) {
        // If the error has a response with data, resolve with that data
        if (error.response?.data) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      }
    });
  },

  updateDefaultBpmByPillCount: (
    id: number,
    defaultBpmByPillCountData: DefaultBpmByPillCountPayload
  ): Promise<DefaultBpmByPillCountSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await putRequest<DefaultBpmByPillCountSingleResponse>(
          `pps/default-bpm-by-pill-counts/${id}/`,
          defaultBpmByPillCountData
        );
        resolve(data);
      } catch (error: any) {
        // If the error has a response with data, resolve with that data
        if (error.response?.data) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      }
    });
  },

  deleteDefaultBpmByPillCount: (id: number): Promise<any> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await deleteRequest(`pps/default-bpm-by-pill-counts/${id}/`);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }
};
